import distance from './distance';
import soils from './soil_lookup.json';

export default function findNearestSoil(userCoords) {
  let nearestSoil = '';
  let tempDistance = null;
  soils.features.forEach((soil) => {
    let dist = distance(
      userCoords.latitude,
      userCoords.longitude,
      soil.geometry.coordinates[1],
      soil.geometry.coordinates[0],
      'K'
    );

    if (tempDistance) {
      if (dist < tempDistance) {
        nearestSoil = soil.properties.lookup_value;
        tempDistance = dist;
      }
    } else {
      nearestSoil = soil.properties.lookup_value;
      tempDistance = dist;
    }
  });

  return nearestSoil;
}
